import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  OnDestroy,
  ViewChild,
} from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CustomDateTableHeaderComponent } from '../custom-date-table/custom-date-table-header/custom-date-table-header.component';
import { DynamicStylesheetComponent } from '../dynamic-stylesheet/dynamic-stylesheet.component';
import { CustomTableCellComponent } from './custom-table-cell/custom-table-cell.component';
import { CustomTableHeaderComponent } from './custom-table-header/custom-table-header.component';

@Component({
  selector: 'app-custom-table',
  templateUrl: './custom-table.component.html',
  styleUrls: ['./custom-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CustomTableComponent implements AfterViewInit, OnDestroy {
  @ViewChild(DynamicStylesheetComponent)
  dynamicStyleSheet?: DynamicStylesheetComponent;
  @ContentChild(CustomTableHeaderComponent)
  tableHeaderComponent?: CustomTableHeaderComponent;
  @ContentChild(CustomDateTableHeaderComponent)
  dateTableHeaderComponent?: CustomDateTableHeaderComponent;

  private destroyed$ = new Subject<void>();

  constructor() {}

  ngAfterViewInit(): void {
    if (this.tableHeaderComponent) {
      this.tableHeaderComponent.headerCellsChanged
        .pipe(takeUntil(this.destroyed$))
        .subscribe((cells) => {
          this.updateHeaderCells(cells);
        });
    } else if (this.dateTableHeaderComponent?.tableHeaderComponent) {
      this.dateTableHeaderComponent.tableHeaderComponent.headerCellsChanged
        .pipe(takeUntil(this.destroyed$))
        .subscribe((cells) => {
          this.updateHeaderCells(cells);
        });
    } else {
      console.log('custom table could not get header');
    }
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  updateHeaderCells(cells: CustomTableCellComponent[]) {
    cells.forEach((cell, index) => {
      this.dynamicStyleSheet?.upsertDynamicCssRule({
        selector: `app-custom-table-cell:nth-of-type(${index + 1})`,
        rules: [
          { cssProperty: 'display', cssValue: `block` },
          { cssProperty: 'min-width', cssValue: `${cell.widthPx || 44}px` },
        ],
      });
    });
  }
}
